import Vue from 'vue';
import Vuex from 'vuex';
import siteData from '@/store/siteData';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        siteData,
    }
});
